import React, { Dispatch, SetStateAction, useEffect } from 'react';
import Button from '../../../components/buttons/Button';
import { formatPriceWithDecimal, getImageSrc, getLabelsByLanguage } from '../../../../utilites/util';
import BankCardsImages from '../bank-cards/BankCardsImages';
import BackArrow from '../../../assets/svg/back.svg';
import { getItemFromSessionStorage } from '../../../../utilites/localStorage';
import { formatMobilePhone } from '../../../../selectors/profileOperator';
import HttpRequest from '../../../../services/HttpRequest';
import _ from 'lodash';
import Topup from '../../../../constants/TopupTypes';
import { topupAnalyticsStepAction } from '../../../../app/store/analytics/actions';
import { useDispatch } from 'react-redux';

interface Props {
  handleStepChange: (stepNumber: number) => void;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setErrors: Dispatch<SetStateAction<string[]>>;
}
const TopupOverviewStep: React.FC<Props> = ({ handleStepChange, setErrors, setLoading }) => {
  const dispatch = useDispatch();
  const labels = getLabelsByLanguage();
  const greenCheck = getImageSrc('', 'green-check', 'png');
  const topupData = getItemFromSessionStorage('topupData', '{}');

  const handleQuit = () => {
    window.scrollTo(0, 0);
    sessionStorage.removeItem('topupData');
    handleStepChange(1);
  };

  const handleFormSubmit = (guest: boolean) => {
    const submitData = {
      topupType: topupData.topupType === Topup.STANDARD ? 'phone' : 'internet',
      msisdn: `${topupData?.prefix1}${topupData?.msisdn1}` || '',
      email: topupData.email || '',
      amount: topupData.amount || '',
      guest: guest,
    };

    HttpRequest.request({
      method: 'POST',
      url: '/topup/payments',
      data: submitData,
    })
      .then((response: any) => {
        sessionStorage.setItem('corvusFormData', JSON.stringify(response));
        sessionStorage.removeItem('topupData');
        window.location.replace(response.redirectUrl);
      })
      .catch((error) => {
        setErrors([error.message]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePaymentClick = (guest: boolean) => {
    handleFormSubmit(guest);
  };

  if (_.isEmpty(topupData)) {
    handleStepChange(1);
  }

  useEffect(() => {
    dispatch(topupAnalyticsStepAction({ step: 2, amount: topupData.amount, topupType: topupData.topupType }));
  }, []);

  return (
    <div className="ytope-form-container">
      <section className=" mb-3 text-left">
        <div className="row">
          <div className="col-12 mt-3">
            <span
              className="custom-back-button__label cursor-pointer yettel-font text-18"
              onClick={() => handleStepChange(1)}
            >
              <img src={BackArrow} alt="back" className="me-1" height="11" />
              {labels.previousStep}
            </span>
          </div>
        </div>
        <p className="yettel-font mt-5 mb-5">{<span dangerouslySetInnerHTML={{ __html: labels.topupText14 }} />}</p>
        <p className="yettel-bold-font text-20">{labels.prepaidTopup}</p>
        <div>
          <span className="yettel-bold-font text-20">1. </span>
          <span className="yettel-font text-16">{labels.topupAdress}</span>
          <p className="ps-3 yettel-bold-font text-16">{topupData?.email}</p>
        </div>
        <div>
          <span className="yettel-bold-font text-20">2. </span>
          <span className="yettel-font text-16"> {labels.topupAmountToPay}</span>
          <p className="ps-3 yettel-bold-font text-16">{formatPriceWithDecimal(topupData?.amount)} RSD</p>
        </div>
        <div>
          <span className="yettel-bold-font text-20">3. </span>
          <span className="yettel-font text-16">{labels.topupMobile}</span>
          <p className="ps-3 yettel-bold-font text-16">
            {formatMobilePhone(`${topupData?.prefix1}${topupData?.msisdn1}`)}
          </p>
        </div>
        <p className="mt-5 yettel-font text-16">{labels.topupText15}</p>
        <p className="mt-5 yettel-font text-16">
          {labels.topupText16} <span className="yettel-bold-font">{formatPriceWithDecimal(topupData?.amount)} RSD</span>
        </p>
        <div className="mt-5 yettel-font text-16 border-top">
          <p className="yettel-bold-font text-18 mt-4">{labels.topupText17}</p>
          <p>{labels.topupText18}</p>
          <p>
            <img src={greenCheck} alt="check" className="me-2" />
            {labels.topupText19}
          </p>
          <p>
            <img src={greenCheck} alt="check" className="me-2" />
            {labels.topupText20}
          </p>
          <p>
            <img src={greenCheck} alt="check" className="me-2" />
            {labels.topupText21}
          </p>
          <p>
            <img src={greenCheck} alt="check" className="me-2" />
            {labels.topupText22}
          </p>
          <p>
            <img src={greenCheck} alt="check" className="me-2" />
            {labels.topupText27}
          </p>
        </div>
        <div className="w-100 justify-content-center align-items-center text-center mt-4 mb-4">
          <Button type="button" disabled={false} onClick={() => handlePaymentClick(false)} style={'btn-blue-yettel'}>
            {labels.topupYettelPay}
          </Button>
        </div>
      </section>

      <div className="container d-flex align-items-center">
        <div className="border" style={{ flex: '1', height: '1px', background: 'grey' }}></div>
        <div className="text mt-0 mb-0 ms-3 me-3">ili</div>
        <div className="border" style={{ flex: '1', height: '1px', background: 'grey' }}></div>
      </div>

      <div className="row p-0 pt-1 pb-1">
        <div className="w-100 justify-content-center align-items-center text-center mt-4 mb-4">
          <Button type="button" disabled={false} onClick={() => handlePaymentClick(true)} style={'btn-white-yettel'}>
            {labels.topupContinueAsGuest}
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mt-3 text-center mb-5" onClick={handleQuit}>
          <a className="custom-back-button">
            <span className="custom-back-button__label yettel-font text-18">{labels.quit}</span>
          </a>
        </div>
      </div>
      <div className="text-center mb-5">
        <p>{labels.topupText25}</p>
      </div>
      <BankCardsImages />
    </div>
  );
};

export default TopupOverviewStep;
